import { Col, Form, Input, Row } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const DraftInputSection = ({
  disabled,
  fieldPrefix,
  validationRules,
  title,
}) => {
  const { t } = useTranslation()

  return (
    <div className="vessel-drafts-table__section">
      <Text className="vessel-drafts-table__section-title">{title}</Text>

      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label={t('portCall.draftSurvey.forward')}
            name={[fieldPrefix, 'forward']}
            rules={validationRules}
          >
            <Input disabled={disabled} type="number" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={t('portCall.draftSurvey.midship')}
            name={[fieldPrefix, 'midship']}
            rules={validationRules}
          >
            <Input disabled={disabled} type="number" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={t('portCall.draftSurvey.aft')}
            name={[fieldPrefix, 'aft']}
            rules={validationRules}
          >
            <Input disabled={disabled} type="number" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}

DraftInputSection.propTypes = {
  disabled: PropTypes.bool.isRequired,
  fieldPrefix: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  validationRules: PropTypes.array.isRequired,
}

export default DraftInputSection
